import { BaseResponseSchema } from '../../schemas/primitives.js';
import { CognitoConfirmSignUpRequestSchema, CognitoForgotPasswordRequestSchema, CognitoForgotPasswordResponseSchema, CognitoMessageResponseSchema, CognitoRefreshTokenRequestSchema, CognitoRefreshTokenResponseSchema, CognitoRegisterRequestSchema, CognitoRegisterResponseSchema, CognitoResetPasswordRequestSchema, CognitoRespondToAuthChallengeRequestSchema, CognitoRespondToAuthChallengeResponseSchema, CognitoSyncUserRequestSchema, CognitoSyncUserResponseSchema, MeResponseSchema, PasswordPolicyResponseSchema, UpdateOwnProfileRequestSchema, UpdateOwnProfileResponseSchema, UploadOwnAvatarFormSchema, UploadOwnAvatarResponseSchema, } from '../../schemas/auth.schemas.js';
import { StepUpAuthRequestSchema, StepUpAuthResponseSchema, } from '../../schemas/step-up-auth.schemas.js';
/** REST contract for `insight-api/src/routes/cognito-auth.routes.ts`. */
export const authContract = {
    register: {
        method: 'POST',
        path: '/unified-auth/register',
        body: CognitoRegisterRequestSchema,
        response: CognitoRegisterResponseSchema,
        responseStyle: 'parse-response',
        skipAuthRefresh: true,
        errorMessage: 'Registration failed',
    },
    confirmSignUp: {
        method: 'POST',
        path: '/unified-auth/confirm',
        body: CognitoConfirmSignUpRequestSchema,
        response: CognitoMessageResponseSchema,
        responseStyle: 'parse-response',
        skipAuthRefresh: true,
        errorMessage: 'Failed to confirm signup',
    },
    respondToAuthChallenge: {
        method: 'POST',
        path: '/unified-auth/respond-to-auth-challenge',
        body: CognitoRespondToAuthChallengeRequestSchema,
        response: CognitoRespondToAuthChallengeResponseSchema,
        responseStyle: 'unwrap-data',
        skipAuthRefresh: true,
        errorMessage: 'Failed to complete authentication challenge',
    },
    refreshToken: {
        method: 'POST',
        path: '/unified-auth/refresh',
        body: CognitoRefreshTokenRequestSchema,
        response: CognitoRefreshTokenResponseSchema,
        responseStyle: 'parse-response',
        skipAuthRefresh: true,
        errorMessage: 'Failed to refresh token',
    },
    forgotPassword: {
        method: 'POST',
        path: '/unified-auth/forgot-password',
        body: CognitoForgotPasswordRequestSchema,
        response: CognitoForgotPasswordResponseSchema,
        responseStyle: 'parse-response',
        skipAuthRefresh: true,
        errorMessage: 'Failed to initiate password reset',
    },
    resetPassword: {
        method: 'POST',
        path: '/unified-auth/reset-password',
        body: CognitoResetPasswordRequestSchema,
        response: CognitoMessageResponseSchema,
        responseStyle: 'parse-response',
        skipAuthRefresh: true,
        errorMessage: 'Failed to reset password',
    },
    syncUser: {
        method: 'POST',
        path: '/unified-auth/sync',
        body: CognitoSyncUserRequestSchema,
        response: CognitoSyncUserResponseSchema,
        responseStyle: 'parse-response',
        skipAuthRefresh: true,
        timeoutMs: 15000,
        errorMessage: 'Failed to sync user',
    },
    getMe: {
        method: 'GET',
        path: '/unified-auth/me',
        response: MeResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get current user',
    },
    updateProfile: {
        method: 'PUT',
        path: '/unified-auth/me/profile',
        body: UpdateOwnProfileRequestSchema,
        response: UpdateOwnProfileResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update profile',
    },
    uploadAvatar: {
        method: 'POST',
        path: '/unified-auth/me/avatar',
        body: UploadOwnAvatarFormSchema,
        bodyStyle: 'form-data',
        response: UploadOwnAvatarResponseSchema,
        responseStyle: 'parse-response',
        timeoutMs: 120000,
        errorMessage: 'Failed to upload avatar',
    },
    deleteAvatar: {
        method: 'DELETE',
        path: '/unified-auth/me/avatar',
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to remove avatar',
    },
    getPasswordPolicy: {
        method: 'GET',
        path: '/unified-auth/password-policy',
        response: PasswordPolicyResponseSchema,
        responseStyle: 'unwrap-data',
        skipAuthRefresh: true,
        errorMessage: 'Failed to get password policy',
    },
    logout: {
        method: 'POST',
        path: '/unified-auth/logout',
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to logout',
    },
    stepUp: {
        method: 'POST',
        path: '/unified-auth/step-up',
        body: StepUpAuthRequestSchema,
        response: StepUpAuthResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Step-up authentication failed',
    },
};
//# sourceMappingURL=auth.contract.js.map